export const fuehrung2026FAQData = [
  {
    question: "Was ist heute wichtiger, Fachwissen oder emotionale Kompetenz?",
    answer: "Emotionale Kompetenz wirkt stärker auf Vertrauen, Zusammenarbeit und Teamleistung. Fachwissen bleibt wichtig, ersetzt aber keine Beziehung."
  },
  {
    question: "Wie schafft man psychologische Sicherheit im Team?",
    answer: "Durch Zuhören, transparente Fehlerkultur, respektvolle Sprache und echtes Interesse an Perspektiven."
  },
  {
    question: "Sollten Führungskräfte stark auf KI oder Automatisierung setzen?",
    answer: "Technologie kann Prozesse erleichtern. Führung selbst bleibt jedoch eine menschliche Aufgabe."
  },
  {
    question: "Wie viel Zeit sollte man für Gespräche einplanen?",
    answer: "Mehr als man denkt. Beziehungspflege ist kein Zusatz, sondern Kern von Führung."
  },
  {
    question: "Kann man emotionale Intelligenz lernen?",
    answer: "Ja. Selbstreflexion, Feedback und Training verbessern nachweislich Wahrnehmung und Selbstregulation."
  }
];
